import React from 'react';
import BodyText from '../../Typography/BodyText/BodyText';
import { SupportedColor, FlexItemProp } from '../../Element/Element';
import { PaddingProps } from '../../Element/getPaddingClasses';
import Button from '../../Button/Button';

export interface ItemPerPageShape {
  /** Sets number of items in each page and resets current page */
  setNumberOfItems: (numberOfItems: number) => void;
  /** Gets number of items each page */
  numberOfItemsEachPage?: number;
  /** Gets list of options to show items in page  */
  numberOfItemsEachPageOptions?: number[];
  /** Sets 'show' text */
  showText?: string;
  /** Sets primary color */
  primaryColor?: SupportedColor;
  /** Sets secondary color */
  secondaryColor?: SupportedColor;
  /** Display BodyText as block */
  block?: boolean;
  /** Padding for the element */
  padding?: PaddingProps;
  /** Set element to be a flex item */
  flexItem?: FlexItemProp;
}
const ItemsPerPage: React.FunctionComponent<ItemPerPageShape> = ({
  setNumberOfItems,
  numberOfItemsEachPage,
  numberOfItemsEachPageOptions = [],
  showText = 'Show',
  padding = { size: 'sm' },
  block = true,
  flexItem = true,
  primaryColor = 'purple500',
  secondaryColor = 'black',
}) => {
  return (
    <BodyText tagName="span" block={block} flexItem={flexItem}>
      {showText}
      {numberOfItemsEachPageOptions.map((option, index) => (
        <Button
          style={{ paddingTop: 0, paddingBottom: 0 }}
          variant="text"
          key={`option-${index}`}
          id={`show-${option}`}
          size="lg"
          padding={padding}
          textVariantProps={{
            color:
              option === numberOfItemsEachPage ? secondaryColor : primaryColor,
            fontWeight: 'bold',
            hoverColor:
              option === numberOfItemsEachPage ? primaryColor : secondaryColor,
          }}
          onClick={() => setNumberOfItems(option)}
        >
          {option}
        </Button>
      ))}
    </BodyText>
  );
};

export default ItemsPerPage;
